import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const PHILO_PROMO_CODE = "2021PHILOTVP4"

export const PhiloGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(PHILO_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({disabled, handleClick}) => {
    return (
      <> 
        <Button
        type="button"
        className="btn"
        primary
        disabled={disabled}
        onClick={() => {
          setSubmissionPromoCode(promoCode)
          handleClick()
        }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
      PHILO_PROMO_CODE
    )
  ];

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>Enter your T-Mobile or Sprint phone number to begin the redemption process. You will then be prompted to log in to your account.</p>
            <p>If you are a Home Internet only customer, please find your assigned billing phone number on your bill under "connected devices". </p>
            <img style={{marginTop: "1rem"}} src={"images/Philo/philo_logo.png"} alt="Philo Logo" className="mb-3"/>
            <p>
              Get $10/month off your Philo subscription for 12 months. Philo offers 60+ channels of live &amp; on-demand TV with Unlimited DVR.
              Stream on up to 3 devices at the same time. Must remain a T-Mobile subscriber to receive monthly discount.
              Subscription automatically renews at $25/mo after first year.
            </p>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{marginBottom: "6px"}}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto"/>
        </div>
        <div className="mx-auto col-md-4">   
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/tvision#faq" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
